<template>
  <SimpleDictView
    endpoint="book/check-types/"
    :title="$t('settings.titles.checkTypes')"
    :add-button="$t('settings.addButtons.checkType')"
    :fields="fields"
  />
</template>
<script>
import SimpleDictView from './SimpleDictView.vue'
export default {
  name: 'CheckTypesView',
  components: { SimpleDictView },
  computed: {
    fields() {
      return [{ key: 'name', label: this.$t('settings.fields.name') }]
    },
  },
}
</script>
